import {
  useEffect,
  useState,
  useMemo,
  forwardRef,
  useImperativeHandle,
  useRef,
} from "react";
import SelectableInput from "components/SelectableInput/SelectableInput";
import EmptyField from "../Records/EmptyField";

const ToggleCreate = (
  { type, field, value, inputSize, onChange, inline, disabled },
  ref
) => {
  const selectRef = useRef();
  const [selected, setSelected] = useState(null);

  const options = useMemo(() => {
    return [
      {
        label: field.TrueDisplayName ?? "True",
        value: true,
        color: "#26b058",
        icon: "mdi mdi-check-bold",
      },
      {
        label: field.FalseDisplayName ?? "False",
        value: false,
        color: "#e72222",
        icon: "mdi mdi-close-thick",
      },
    ];
  }, [field]);

  useEffect(() => {
    if (typeof value !== "boolean") return setSelected(null);

    setSelected(value);
  }, [value]);

  const onSelect = (newValue) => {
    setSelected(newValue?.value);
    onChange(newValue?.value);
  };

  const onDeselect = () => {
    setSelected(null);
    onChange("");
  };

  const onClear = () => {
    setSelected(null);
    onChange("");
  };

  useImperativeHandle(ref, () => ({
    focus: () => selectRef.current?.focus(),
  }));

  return (
    <SelectableInput
      ref={selectRef}
      options={options}
      value={
        selected === true
          ? { label: field.TrueDisplayName, value: true, color: "#26b058" }
          : selected === false
          ? { label: field.FalseDisplayName, value: false, color: "#e72222" }
          : ""
      }
      onSelect={onSelect}
      onDeselect={onDeselect}
      onClear={onClear}
      color="#DC5013"
      sort={false}
      searchable={false}
      empty={<EmptyField table={false} />}
    />
  );
};

export default forwardRef(ToggleCreate);
